import { useLoadingStore } from '@/stores/loading'

const loading = {
  show () {
    useLoadingStore().show()
  },
  hide () {
    useLoadingStore().hide()
  },
}

export default loading
